export function calculateInnerContentHeight({
    pageContentHeight,
    headerHeight,
    headerOffset,
    summaryBarHeight,
    footerHeight,
    hasNavbarOffset,
    hasTrialStatusBarOffset,
}: {
    pageContentHeight: number;
    headerHeight: number;
    headerOffset: number;
    summaryBarHeight: number;
    footerHeight: number;
    hasNavbarOffset: boolean;
    hasTrialStatusBarOffset: boolean;
}) {
    return (
        pageContentHeight -
        headerHeight -
        headerOffset -
        summaryBarHeight -
        footerHeight +
        (hasNavbarOffset ? 56 : 0) +
        (hasTrialStatusBarOffset ? 45 : 0)
    );
}
